export const styles = {
  wrapper: {
    display: 'flex',
    width: '100%',
    alignItems: 'flex-end',
    justifyContent: 'center',
    minHeight: '64px',
    gap: '10px',
    padding: '10px',
    boxSizing: 'border-box',
  },
  input: {
    flex: 1,
  },
  inputWrapper: {
    flex: 1,
    position: 'relative',
    maxWidth: '780px',
  },
  fileButton: {
    position: 'absolute',
    left: '12px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
};
